export default __webpack_public_path__ + "2da6f956a3e8fd5d1706ac6ed581007c.svg";